import React, { useState } from "react";
import {Nav, Navbar as BootstrapNavbar, Container, Modal, Button, Spinner, Dropdown} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faUsers,
    faCubes,
    faCopy,
    faCog,
    faSignOutAlt,
    faSignIn,
    faUser, faArrowLeft, faBasketShopping,
    faTachometer,
    faGears,
    faBarcode,
    faChartSimple,
    faChartGantt
} from "@fortawesome/free-solid-svg-icons";
import {FrontEndRoutes} from "../config/front-end-routes";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

function Navbar() {
    const [loading, setLoading] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false)
    const navigate = useNavigate();
    //const [isAdmin, setIsAdmin] = useState<boolean>(false)

    const logout = () => {
        console.log('logout');
        localStorage.removeItem('token');
        localStorage.removeItem("authToken")
        navigate(FrontEndRoutes.LOGIN);
        setShowModal(false)
    };
    const handleLogout = () => {
        setShowModal(true);
    }

    const heandleClick = () => {
        //TODO:
    };

    return (
        <BootstrapNavbar variant="dark" expand="lg" style={{background: '#3490dc'}}>
            <Container
                fluid
                className="py-2 py-lg-1" // Reduz o padding vertical no modo desktop
            >
                {/* Título no lado esquerdo */}
                <BootstrapNavbar.Brand as={Link} to="/index" className="text-light">
                    CappellusWeb
                </BootstrapNavbar.Brand>

                {/* Botão para expandir o menu no modo mobile */}
                <BootstrapNavbar.Toggle aria-controls="navbarText" />

                {/* Itens do menu */}
                <BootstrapNavbar.Collapse id="navbarText">
                    <Nav className="w-100 d-flex flex-column flex-lg-row align-items-lg-center gap-1 mt-1 mt-lg-0">
                        {/* Menu alinhado à esquerda no desktop */}
                        <Nav className="me-auto">
                            <Nav.Link
                                as={Link}
                                to={FrontEndRoutes.HOME}
                                className="text-light px-3 py-2 rounded hover-bg-secondary"
                            >
                                <FontAwesomeIcon icon={faHome} /> Home
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to={FrontEndRoutes.CLIENTES.LIST}
                                className="text-light px-3 py-2 rounded hover-bg-secondary"
                            >
                                <FontAwesomeIcon icon={faUsers} /> Clientes
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to={FrontEndRoutes.USUARIOS.LIST}
                                className="text-light px-3 py-2 rounded hover-bg-secondary"
                            >
                                <FontAwesomeIcon icon={faUsers} /> Usuários
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to={FrontEndRoutes.PRODUTOS.LIST}
                                className="text-light px-3 py-2 rounded hover-bg-secondary"
                            >
                                <FontAwesomeIcon icon={faCubes} /> Produtos
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to={FrontEndRoutes.PEDIDOS.LIST}
                                className="text-light px-3 py-2 rounded hover-bg-secondary"
                            >
                                <FontAwesomeIcon icon={faBasketShopping} /> Pedidos
                            </Nav.Link>

                            <Dropdown>
                                <Dropdown.Toggle
                                    className="text-light px-3 py-2 rounded hover-bg-secondary"
                                    id="dropdown-basic"
                                    as="div"
                                    style={{
                                        cursor: "pointer",
                                        color: "white",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <FontAwesomeIcon icon={faChartGantt} /> &nbsp;Dashboard
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        as={Link}
                                        to={FrontEndRoutes.DASHBOARD}
                                    >
                                        <FontAwesomeIcon icon={faChartSimple} /> Dashboard
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            <Dropdown>
                                <Dropdown.Toggle
                                    className="text-light px-3 py-2 rounded hover-bg-secondary"
                                    id="dropdown-basic"
                                    as="div"
                                    style={{
                                        cursor: "pointer",
                                        color: "white",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <FontAwesomeIcon icon={faGears} /> &nbsp;Configurações
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to={FrontEndRoutes.CONFIG}>
                                        <FontAwesomeIcon icon={faCog} /> Configurações
                                    </Dropdown.Item>
                                    <hr />
                                    {/* <Dropdown.Item as={Link}  to={FrontEndRoutes.PRAZOS_PAGAMENTO}>
                                        Prazos De Pagamento
                                    </Dropdown.Item> */}
                                    <Dropdown.Item as={Link} to={FrontEndRoutes.TABELA.PRECO}>
                                    <FontAwesomeIcon icon={faBarcode} /> Tabela de Preços
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>

                        {/* Botão de sair no lado direito */}
                        <Nav className="mt-3 mt-lg-0">
                            <Nav.Link
                                onClick={handleLogout}
                                className="text-light d-flex gap-1 align-items-center px-3 py-2 rounded hover-bg-secondary"
                            >
                                <FontAwesomeIcon icon={faSignOutAlt} /> Sair
                            </Nav.Link>
                        </Nav>
                    </Nav>
                </BootstrapNavbar.Collapse>

            </Container>
            <Modal show={showModal} onHide={() => setShowModal(false)} size="sm">
                <Modal.Header
                    closeButton
                    style={{ background: "var(--color-profile-1)", color: "white" }}
                >
                    <Modal.Title>Confirmar Logout</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Tem certeza que deseja sair?
                </Modal.Body>
                <Modal.Footer style={{ background: "var(--color-profile-1)" }}>
                    <Button
                        variant="secondary"
                        size="sm"
                        disabled={loading}
                        onClick={() => setShowModal(false)}
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                        {loading ? (
                            <Spinner as="span" animation="border" size="sm" />
                        ) : (
                            "Cancelar"
                        )}
                    </Button>
                    <Button
                        variant="primary"
                        size="sm"
                        disabled={loading}
                        onClick={logout}
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        {loading ? (
                            <Spinner as="span" animation="border" size="sm" />
                        ) : (
                            "Sair"
                        )}
                        {/*//<FontAwesomeIcon icon={faAccountLogout} />*/}
                    </Button>
                </Modal.Footer>
            </Modal>
        </BootstrapNavbar>
    );
}

export default Navbar;
